export const ChatMediaAutoImgModeOffIcon = ({
  size = 30,
  className,
}: {
  size?: number
  className?: string
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    className={className}
  >
    <g>
      <path
        d="M12.5586 17.7278L13.3389 15.9999M17.4422 17.7278L16.7465 15.9999M16.7465 15.9999L15.0323 12.2783L13.3389 15.9999M16.7465 15.9999H13.3389"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53676 9.86158C8.27383 11.2038 7.5 13.0116 7.5 15C7.5 19.1421 10.8579 22.5 15 22.5L13.8265 20.2996M20.307 20.2996C21.662 18.9427 22.5 17.0692 22.5 15C22.5 10.8579 19.1421 7.5 15 7.5L16.2326 9.56971"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
